// src/firebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import {
  getAnalytics,
  isSupported,
  setUserProperties,
} from "firebase/analytics";
import { APP_VERSION } from "./constants/appVersion";
import { getDisplayMode } from "./utils/displayMode";
import { definedOnly, describeHardware } from "./utils/diagnosticsContext";

// Configuracion de Firebase TDC
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  databaseURL: import.meta.env.VITE_FIREBASE_TDC_DATABASE_URL,
};

// Configuracion de Firebase TruckYard
const firebaseConfig2 = {
  apiKey: import.meta.env.VITE_FIREBASE_TRUCKYARD_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_TRUCKYARD_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_TRUCKYARD_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_TRUCKYARD_STORAGE_BUCKET,
  messagingSenderId: import.meta.env
    .VITE_FIREBASE_TRUCKYARD_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_TRUCKYARD_APP_ID,
};

const app = initializeApp(firebaseConfig, "TDC");

// Only initialize TruckYard if API key is configured
const app2 = firebaseConfig2.apiKey
  ? initializeApp(firebaseConfig2, "TruckYard")
  : null;

export const auth = getAuth(app);
export const auth2 = app2 ? getAuth(app2) : null;

export const database = getDatabase(app);
export const storage = getStorage(app);

// Initialize Analytics lazily (only in browser environment)
let analyticsInstance: ReturnType<typeof getAnalytics> | null = null;

export const getAnalyticsInstance = async () => {
  if (analyticsInstance) return analyticsInstance;

  const supported = await isSupported();
  if (supported) {
    analyticsInstance = getAnalytics(app);
    // Set app version for release tracking
    setUserProperties(analyticsInstance, {
      app_version: APP_VERSION,
      display_mode: getDisplayMode(),
      ...definedOnly(describeHardware()),
    });
  }
  return analyticsInstance;
};

export default app;
